import { cn } from "@portal/components/lib/utils";
import { ReactNode } from "react";

export const AdminActionItemLayout = ({
	testId,
	containerClassName,
	statusIcon,
	content,
	footer,
	isSelected,
	withHover,
}: {
	testId?: string;
	statusIcon: ReactNode;
	content: ReactNode;
	footer?: ReactNode;
	containerClassName?: string;
	isSelected?: boolean;
	withHover?: boolean;
}) => {
	return (
		<div
			data-testid={testId}
			className={cn(
				"relative flex flex-col border-b-1 border-b-[1px] border-gray-100 overflow-hidden",
				containerClassName,
			)}
		>
			<div
				className={cn(
					isSelected &&
						"absolute -inset-1 bg-gradient-to-r from-blue-600 to-blue-200 rounded-lg blur opacity-50",
				)}
			/>
			<div
				className={cn(
					"relative z-10 p-6 flex flex-col gap-2 bg-white m-0.5 mt-[3px] rounded-sm width-[98.35%]",
					withHover && "hover:bg-gray-50",
				)}
			>
				<div className="relative flex gap-3 items-start justify-start w-full ">
					<div className="mt-[1px] self-start min-w-fit">{statusIcon}</div>
					<>{content}</>
				</div>
				{footer && <div className="flex justify-start gap-4 w-full mt-2">{footer}</div>}
			</div>
		</div>
	);
};
